export const PALETTE = {
  BLACK: 'rgb(17, 17, 17)',
  WHITE: 'rgb(256, 256, 256)',
  OFF_WHITE: 'rgb(240, 235, 219)',
  GREY_1: '#EFEFEF',
  GREY_2: '#C6C6C6',
  GREY_3: '#F2F2F2',
  DARK_GREEN: 'rgb(35, 51, 32)',
  LIGHT_GREEN: 'rgb(120, 130, 83)',
  ORANGE: 'rgb(206, 77, 46)',
  YELLOW: 'rgb(228, 170, 59)',
}

export const COLOR = {
  BASE_ACCENT: PALETTE.PURPLE,
  BASE_BACKGROUND: PALETTE.WHITE,
  BASE_FONT: PALETTE.BLACK,
  LINK_FONT: PALETTE.BLACK,
  ...PALETTE,
}
